import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'


export default props => {
    useStyles(classes)

    return <div className={`${classes.Container} ${props?.className ? props.className : ""}`}>
        <span className={classes.Content}>
            {
                props?.title || <FormattedMessage id="sign_to_sync_bag" defaultMessage="Sign to sync your shopping bag"/>
            }
        </span>
        <button className={classes.Button} onClick={props?.onLogin}>
            <FormattedMessage id="sign_in" defaultMessage="Sign In"/>
        </button>
    </div>
}